import React, { useCallback } from 'react'

import './index.scss'

export default React.memo(function({
    info,
    closeAlert
}) {
    const btnClick = useCallback((action)=> {
        closeAlert && closeAlert()
        action && action()
      }, [])
  return (
    <div className='com-alert'>
       <div className='com-alert-box'>
            <img className="alert-close" onClick={btnClick.bind(null, null)} src='https://img12.360buyimg.com/imagetools/jfs/t1/172493/34/3212/598/6071ac75E94f9fbad/a1e8155f165fd7df.png' alt=""  />
            <div className='alert-title'>{info.title}</div>
            {info.reward? <RewardAlert info={info.reward}/>: null}
            <div className='alert-btn' onClick={btnClick.bind(null, info.action)}>{info.btnText}</div>
       </div>
    </div>
  )
})

function RewardAlert({
  info
}) {
  return (
    <div className="couponReward">
      <p className="text-truncate">{info.rewardName}</p>
      {/* <p className="price">{info.rewardAmountDesc}</p> */}
      {/* <div className="line"></div> */}
      {/* <div className="content"> */}
        {/* <p className="text-truncate">{info.rewardName || info.reachTitle}</p> */}
        {/* <p className="text-truncate">{info.rewardName}</p> */}
      {/* </div> */}
      {/* {
        info.rewardLabel?
        <div className="jiao">
          <p>{info.rewardLabel}</p>
        </div> : null
      } */}
    </div>
  )
}
